import { render, staticRenderFns } from "./relation-name.vue?vue&type=template&id=21f846a2&scoped=true"
import script from "./relation-name.vue?vue&type=script&lang=ts"
export * from "./relation-name.vue?vue&type=script&lang=ts"
import style0 from "./relation-name.vue?vue&type=style&index=0&id=21f846a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f846a2",
  null
  
)

export default component.exports